/**
 * Indicator 324 pictogram SVGs loaded from local assets (no runtime fetch).
 * Used by InventoryCircleAnalysis for TYPE_OUVRAGE-based map symbols.
 */
import factorySvg from './factory.svg?raw'
import farmWaterTowerSvg from './farm-water-tower.svg?raw'
import filterSvg from './filter.svg?raw'
import fountainSvg from './fountain.svg?raw'
import reservoirPointSvg from './reservoir-point.svg?raw'
import waterTankSvg from './water-tank.svg?raw'
import waterTapSvg from './water-tap.svg?raw'
import waterWellSvg from './water-well.svg?raw'
import wellSvg from './well.svg?raw'
import wellForageSvg from './well-forage.svg?raw'

export const INDICATOR_324_ICON_KEYS = [
  'well',
  'well-forage',
  'water-tap',
  'water-well',
  'factory',
  'water-tank',
  'filter',
  'farm-water-tower',
  'fountain',
  'reservoir-point',
] as const

export type Indicator324IconKey = (typeof INDICATOR_324_ICON_KEYS)[number]

const SVG_BY_ICON_KEY: Record<Indicator324IconKey, string> = {
  well: wellSvg,
  'well-forage': wellForageSvg,
  'water-tap': waterTapSvg,
  'water-well': waterWellSvg,
  factory: factorySvg,
  'water-tank': waterTankSvg,
  filter: filterSvg,
  'farm-water-tower': farmWaterTowerSvg,
  fountain: fountainSvg,
  'reservoir-point': reservoirPointSvg,
}

export const DEFAULT_INDICATOR_324_ICON_KEY: Indicator324IconKey = 'well'

export function getSvgForIndicator324IconKey(key: string): string {
  const iconKey = key as Indicator324IconKey
  return SVG_BY_ICON_KEY[iconKey] ?? SVG_BY_ICON_KEY[DEFAULT_INDICATOR_324_ICON_KEY]
}

export function getIndicator324IconKeysForIteration(): Indicator324IconKey[] {
  return [...INDICATOR_324_ICON_KEYS]
}
